import { ApiClient } from './ApiClient';
import { Tracker, TrackerAttributes, TrackerOperationAttributes } from '~/models/Tracker';

export default class TemplateApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/templates';

  public async cloneTemplate(id: number): Promise<Tracker> {
    const response = await this.post(`${this.BASE_URL}/clone`, { id });
    return new Tracker(response.data);
  }

  public async createTemplate(attributes: TrackerOperationAttributes) {
    return this.post(this.BASE_URL, attributes);
  }

  public async provideTemplate(templateId: number): Promise<Tracker> {
    const response = await this.get(this.BASE_URL + `/${templateId}`);
    return new Tracker(response.data);
  }

  public async provideTemplates(): Promise<Tracker[]> {
    const response = await this.get(this.BASE_URL);
    return response.data.map((attributes: TrackerAttributes) => new Tracker(attributes));
  }

  public async updateTemplate(attributes: TrackerOperationAttributes): Promise<Tracker> {
    const response = await this.patch(this.BASE_URL, attributes);
    return new Tracker(response.data);
  }
}
